// Dynamic API Base URL detection
// Localhost: Uses 3000 (frontend) -> 3001 (backend)
// VM: Uses 3005 (frontend) -> 3006 (backend)
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;

  // React local dev server
  if (port === '3000') {
    return `${protocol}//${hostname}:3001`;
  }
  
  // Docker compose environment
  if (port === '3005') {
    return `${protocol}//${hostname}:3006`;
  }

  // Production fallback
  return "https://datalift.canexus.ai";
};

export const API_BASE_URL = getApiBaseUrl();
